import { Icon } from "@blueprintjs/core"
import CustomTag from "components/Atoms/CustomTag"
import CustomTooltip from "components/Atoms/CustomTooltip"
import ROUTES from "constants/routes.constants"
import { startCase } from "lodash-es"
import React, { useCallback } from "react"
import { NavLink, useLocation, useParams } from "react-router-dom"
import useDCStore from "./dc.store"
type DCFormTabProps = {
  tab?: any
  parentId?: string
}
const DCFormTab = ({ tab, parentId }: DCFormTabProps) => {
  const location = useLocation()
  const { id } = useParams<{ id: string }>()
  const tabId = tab.id
  const formKey = tab.formKey
  const [errorList, changes, dcId] = useDCStore(
    useCallback(
      store => [
        store.errors[formKey]?.list,
        store.changed[formKey],
        store.state.basicDetails.id,
      ],
      [formKey]
    )
  )

  const changeList =
    changes &&
    Object.keys(changes).filter(change => {
      if (change === "id") return false
      return true
    })

  const disabled = !dcId && parentId !== "primaryDetails"
  return (
    <NavLink
      aria-disabled={disabled ? "true" : "false"}
      onClick={e => {
        if (disabled) {
          e.preventDefault()
        }
      }}
      key={tab.id}
      to={{
        pathname: ROUTES.dcDetail(id, tabId),
        search: location.search,
      }}
    >
      <span>
        {errorList?.length > 0 && (
          <CustomTooltip
            position="bottom-left"
            content={
              <div>
                {errorList.map(error => (
                  <p className="my-0" key={error}>
                    {error}
                  </p>
                ))}
              </div>
            }
          >
            <Icon className="mr-2" icon="warning-sign" intent="danger" />
          </CustomTooltip>
        )}
        {tab.title}
      </span>
      {changeList?.length && dcId ? (
        <CustomTooltip
          position="bottom-left"
          content={
            <div>
              <p className="font-600 mb-1">{changeList.length} changes done</p>
              {changeList
                .filter(change => {
                  if (Number(change) || change === "0") return false
                  return true
                })
                .map(change => (
                  <p className="my-0" key={change}>
                    {startCase(change)}
                  </p>
                ))}
            </div>
          }
        >
          <CustomTag round minimal intent="warning">
            {changeList.length}
          </CustomTag>
        </CustomTooltip>
      ) : null}
    </NavLink>
  )
}

export default DCFormTab
